module.exports = __webpack_public_path__ + "img/s3-img2.b1addbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s3-img2.png
// module id = 413
// module chunks = 0